import { isTotalRowClassName } from './isTotalRowClassName';

export type StripeRowConfig = {
  hasColTitle?: boolean;
  colTitleRow?: number;
  showFirstRowAsTitle?: boolean;
};

export type StripeExemptRow = {
  largeHeader?: boolean;
  isLegend?: boolean;
  isTotal?: boolean | null;
  className?: string | null;
  titleClassName?: string | null;
};

export const isStripeExemptRow = (
  row: StripeExemptRow | null | undefined,
  rowIndex: number,
  stripeRowConfig: StripeRowConfig = {}
): boolean => {
  if (!row) {
    return false;
  }

  const { hasColTitle = true, colTitleRow = 0, showFirstRowAsTitle = true } = stripeRowConfig;

  if (row.largeHeader || row.isLegend || row.isTotal) {
    return true;
  }

  const className = [row.className, row.titleClassName].filter(Boolean).join(' ');

  if (className.includes('table-header')) {
    return true;
  }

  if (isTotalRowClassName(className)) {
    return true;
  }

  if (hasColTitle && rowIndex === colTitleRow) {
    return true;
  }

  if (rowIndex === 0 && hasColTitle && showFirstRowAsTitle) {
    return true;
  }

  return false;
};
